import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusAuto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFocusAuto"><Path d="M3.5 8V3.5H8M3.5 16V20.5H8M16 3.5H20.5V8M20.5 16V20.5H16" stroke="currentColor" strokeLinecap="square"/><Path fillRule="evenodd" clipRule="evenodd" d="M8.04306 15.8376L11.5109 8H12.4891L15.9569 15.8376C15.9804 15.8906 15.9945 15.9453 16 16H14.8618L13.9179 13.8667H10.0821L9.13823 16H8C8.0055 15.9453 8.01962 15.8906 8.04306 15.8376ZM13.4459 12.8L12 9.53209L10.5541 12.8H13.4459Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusAuto;
